module.exports = __webpack_public_path__ + "img/news.18289082.png";